import { render, staticRenderFns } from "./scan_code.vue?vue&type=template&id=6830c4b2&scoped=true"
import script from "./scan_code.vue?vue&type=script&lang=js"
export * from "./scan_code.vue?vue&type=script&lang=js"
import style0 from "./scan_code.vue?vue&type=style&index=0&id=6830c4b2&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6830c4b2",
  null
  
)

export default component.exports